<script>
import LABELS from '@/constants/labels'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    mappingLabels() {
      return LABELS
    },
  },

  methods: {},
}
</script>

<template>
  <s-modal :show="visible" :isCustomBg="true">
    <div v-if="visible" class="portrait-mode">
      <div class="portrait-mode_content">
        <p class="portrait-mode_title">
          {{ mappingLabels.portraitModeTitle }}
        </p>
        <div class="portrait-mode_image">
          <img src="images/portrait-mode-img.png" alt="Portrait Mode" />
        </div>
        <p class="portrait-mode_desc">{{ mappingLabels.portraitModeDesc }}</p>
      </div>
    </div>
  </s-modal>
</template>

<style lang="scss" scoped>
@import './modal-portrait-mode.scss';
</style>
